"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _url = require("url");
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _Select = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Select"));
var eventHandlerUtils = _interopRequireWildcard(require("../../../utils/events"));
var refUtils = _interopRequireWildcard(require("../../../utils/refs"));
var _AddPillButton = _interopRequireDefault(require("../../AddPillButton"));
var _PillLink = _interopRequireDefault(require("../../PillLink"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var TrashIcon = function TrashIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7 3.947C7 2.704 8.143 2 9.143 2h5.714c1 0 2.143.704 2.143 1.947V5h3a1 1 0 1 1 0 2h-.198l-.75 13.114A2 2 0 0 1 17.056 22H6.945a2 2 0 0 1-1.997-1.886L4.198 7H4a1 1 0 0 1 0-2h3V3.947zM9 5h6V4H9v1zM6.202 7l.743 13h10.11L17.8 7H6.202zM10 9a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1z"
  }));
};
TrashIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "category": "Category__category__1wzHA",
  "name": "Category__name__17LbY",
  "trash-icon": "Category__trash-icon__1sVZf",
  "trashIcon": "Category__trash-icon__1sVZf",
  "values": "Category__values__3IxKT",
  "pill": "Category__pill__2QLzP",
  "pill-span": "Category__pill-span__2G4g2",
  "pillSpan": "Category__pill-span__2G4g2",
  "value-select": "Category__value-select__GfHiC",
  "valueSelect": "Category__value-select__GfHiC",
  "icon": "Category__icon__5MKwg"
}; 
require('./Category.css');
var getUnselectedValues = function getUnselectedValues(category, acceptedValues) {
  return acceptedValues.filter(function (val) {
    return !category.value.includes(val);
  });
};
var Category = /*#__PURE__*/function (_React$Component) {
  function Category() {
    var _this;
    (0, _classCallCheck2.default)(this, Category);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Category, [].concat(args));
    (0, _defineProperty2.default)(_this, "addValueRef", /*#__PURE__*/_react.default.createRef());
    (0, _defineProperty2.default)(_this, "state", {
      isCreating: false
    });
    (0, _defineProperty2.default)(_this, "getCategoryURL", function (categoryValue) {
      var _this$props = _this.props,
        category = _this$props.category,
        getPath = _this$props.getPath;
      var categoryName = category.key;
      var pathname = getPath('home');
      var query = {
        search: "category:\"".concat(categoryName, "\" = \"").concat(categoryValue, "\""),
        show: 'all'
      };
      return (0, _url.format)({
        pathname: pathname,
        query: query
      });
    });
    (0, _defineProperty2.default)(_this, "handleCategoryValueSelected", function (_ref) {
      var itemsSelected = _ref.itemsSelected;
      var _this$props2 = _this.props,
        category = _this$props2.category,
        onUpdateAssetCategory = _this$props2.onUpdateAssetCategory;
      _this.leaveCreatingState();
      onUpdateAssetCategory({
        key: category.key,
        displayName: category.displayName,
        value: category.value.concat([itemsSelected.value])
      });
    });
    (0, _defineProperty2.default)(_this, "enterCreatingState", function () {
      _this.setState({
        isCreating: true
      });
    });
    (0, _defineProperty2.default)(_this, "leaveCreatingState", function () {
      _this.setState({
        isCreating: false
      });
    });
    (0, _defineProperty2.default)(_this, "togglePopupState", function () {
      var onToggleCategorySelect = _this.props.onToggleCategorySelect;
      process.nextTick(function () {
        return onToggleCategorySelect(false);
      });
    });
    return _this;
  }
  (0, _inherits2.default)(Category, _React$Component);
  return (0, _createClass2.default)(Category, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var category = this.props.category;
      if (!category.value.length) {
        refUtils.focus(this.addValueRef);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
        category = _this$props3.category,
        acceptedValues = _this$props3.acceptedValues;
      var previousUnselectedValues = getUnselectedValues(prevProps.category, prevProps.acceptedValues);
      var currentUnselectedValues = getUnselectedValues(category, acceptedValues);
      if (previousUnselectedValues.length !== currentUnselectedValues.length) {
        refUtils.focus(this.addValueRef);
      }
    }
  }, {
    key: "handleRemoveValue",
    value: function handleRemoveValue(removedValue) {
      var _this$props4 = this.props,
        category = _this$props4.category,
        onUpdateAssetCategory = _this$props4.onUpdateAssetCategory,
        onRemoveAssetCategory = _this$props4.onRemoveAssetCategory;
      var newValue = category.value.filter(function (value) {
        return value !== removedValue;
      });
      if (newValue.length === 0) {
        onRemoveAssetCategory(category);
      } else {
        onUpdateAssetCategory({
          key: category.key,
          displayName: category.displayName,
          value: newValue
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var isCreating = this.state.isCreating;
      var _this$props5 = this.props,
        category = _this$props5.category,
        acceptedValues = _this$props5.acceptedValues,
        onRemoveAssetCategory = _this$props5.onRemoveAssetCategory,
        onToggleCategorySelect = _this$props5.onToggleCategorySelect;
      var unselectedValues = getUnselectedValues(category, acceptedValues);
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": "asset-category",
        className: styles.category
      }, /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": "asset-category-name",
        className: styles.name
      }, /*#__PURE__*/_react.default.createElement("span", null, category.displayName), /*#__PURE__*/_react.default.createElement("span", {
        role: "button",
        "aria-label": "Delete ".concat(category.displayName, " category"),
        "data-test-id": "asset-remove-category",
        className: styles.trashIcon,
        tabIndex: 0,
        onClick: function onClick() {
          return onRemoveAssetCategory(category);
        },
        onKeyDown: eventHandlerUtils.onEnterKey(function () {
          return onRemoveAssetCategory(category);
        })
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        className: styles.icon,
        size: "xs"
      }, /*#__PURE__*/_react.default.createElement(TrashIcon, null)))), /*#__PURE__*/_react.default.createElement("div", {
        className: styles.values,
        "aria-live": "polite"
      }, (category.value || []).map(function (value, index) {
        return /*#__PURE__*/_react.default.createElement(_PillLink.default
        // eslint-disable-next-line react/no-array-index-key
        , {
          key: "".concat(category.key, "-").concat(category.value, "-").concat(index),
          to: _this2.getCategoryURL(value),
          title: value,
          "aria-label": "Go to category ".concat(value),
          onRemove: function onRemove() {
            return _this2.handleRemoveValue(value);
          }
        }, value);
      }), isCreating ? /*#__PURE__*/_react.default.createElement(_Select.default, {
        className: styles.valueSelect,
        testId: "category-value",
        name: "category-value",
        placeholder: "Select a value",
        noResultsText: "No results",
        options: unselectedValues.map(function (value) {
          return {
            label: value,
            value: value
          };
        }),
        onChange: this.handleCategoryValueSelected,
        onBlur: this.leaveCreatingState,
        onOpen: onToggleCategorySelect(true),
        onClose: this.togglePopupState,
        openAfterFocus: true,
        autofocus: true,
        autosize: false
      }) : null, unselectedValues.length ? !isCreating ? /*#__PURE__*/_react.default.createElement(_AddPillButton.default, {
        ref: this.addValueRef,
        "data-test-id": "add-value",
        className: styles.action,
        tabIndex: 0,
        onClick: this.enterCreatingState,
        onKeyDown: eventHandlerUtils.onEnterKey(this.enterCreatingState)
      }, "Add value") : null : /*#__PURE__*/_react.default.createElement("span", {
        ref: this.addValueRef,
        tabIndex: -1,
        className: "visually-hidden"
      }, "No values left to add")));
    }
  }]);
}(_react.default.Component);
var _default = exports.default = Category;
//# sourceMappingURL=Category.js.map